<template>
  <div class="ai-service-home">
    <!-- 导航栏 -->
    <nav class="nav-bar">
        <div class="logo">
          <span class="logo-symbol"><img src="https://aics-public.oss-cn-beijing.aliyuncs.com/images/sunrise-logo.png" width="60" height="60" alt="小晖智能客服"/></span>
          <span>小晖AI客服平台</span>
        </div>
        <div class="nav-links">
          <a href="/solutions">行业解决方案</a>
          <a href="/product-intro">产品介绍</a>
          <a href="/Pricing"> 定价策略</a>
          <a href="#"> 技术博客</a>
          <a href="#">关于我们</a>
          <a href="/login" class="secondary-btn">登录</a>
        </div> 
      <!-- 网站建设中标识 -->
      <div class="construction-banner">
        <div class="construction-content">
          <span class="construction-icon">🚧</span>
          <span class="construction-text">网站建设中，敬请期待</span>
        </div>
      </div>   
    </nav>  
 
    <!-- 首屏Hero -->
    <section class="hero-section">
         <!-- 添加粒子背景 -->
         <ParticlesBackground />

      <div id="particles-js" class="particles-container"></div>
      <div class="grid-dots"></div>
      <div class="hero-content">
        <h1 class="hero-title">旧时王谢堂前燕 飞入寻常百姓家</h1>
        <p class="hero-subtitle">适用于中小企业、小微实体的AI客服平台，少和朋友喝一次咖啡即可拥有您的专属AI客服</p>
        <div class="button-group">
          <a href="/register" class="primary-btn">注册</a>
          <a class="secondary-btn">体验AI客服</a>
        </div>
      </div>
    </section>

    <!-- 功能亮点 -->
    <section class="features-section">
      <h2 class="section-title">为什么选择小晖AI客服</h2>
      <div class="features-grid">
        <div class="feature-card" v-for="(feature, index) in features" :key="index">
          <div class="feature-icon" v-if="index === 0"><svg t="1760352306188" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1877" width="64" height="64"><path d="M1024 926.427429v48.786285h-219.428571v-926.47619h219.428571V97.52381h-170.666667v390.070857h170.666667v48.737523h-170.666667v390.095239h170.666667z m-487.619048 48.786285v-926.47619h219.428572V97.52381h-170.666667v390.070857h170.666667v48.737523h-170.666667v390.095239h170.666667v48.786285h-219.428572z m-97.523809-341.333333c0-99.035429-97.52381-97.54819-97.52381-97.548191v-2.681904c-14.506667 2.584381-24.380952 2.681905-24.380952 2.681904v438.881524h-48.761905v-926.47619h48.761905c145.505524 0 146.285714 146.285714 146.285714 146.285714v195.023238c0 57.417143-22.844952 92.086857-50.395428 113.273905C486.887619 540.988952 487.619048 633.880381 487.619048 633.880381v341.333333h-48.761905v-341.333333z m-24.380953-243.833905V195.023238C414.47619 95.98781 316.952381 97.52381 316.952381 97.52381v390.070857c99.035429 0 97.52381-97.54819 97.523809-97.548191zM48.761905 975.213714H0v-926.47619h219.428571V97.52381H48.761905v390.070857h170.666666v48.737523H48.761905v438.881524z" fill="#1296db" p-id="1878"></path></svg></div>
          <div class="feature-icon" v-if="index === 1"><svg t="1760353436815" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3105" width="64" height="64"><path d="M509.155556 772.266667A273.066667 273.066667 0 1 1 782.222222 499.2a273.066667 273.066667 0 0 1-273.066666 273.066667z m0-500.622223a227.555556 227.555556 0 1 0 227.555555 227.555556 227.555556 227.555556 0 0 0-227.555555-227.555556z" fill="#4D4D4D" p-id="3106"></path><path d="M509.155556 696.888889a196.266667 196.266667 0 1 1 196.266666-196.266667A196.266667 196.266667 0 0 1 509.155556 696.888889z m0-376.888889a182.044444 182.044444 0 1 0 182.044444 180.622222 180.622222 180.622222 0 0 0-182.044444-180.622222z" fill="#4D4D4D" p-id="3107"></path><path d="M573.155556 536.177778h-48.355556v-19.911111h48.355556a18.488889 18.488889 0 1 0 0-36.977778h-28.444445l36.977778-44.088889a18.488889 18.488889 0 1 0-28.444445-25.6l-46.933333 55.466667-45.511111-55.466667a19.911111 19.911111 0 0 0-27.022222-1.422222 18.488889 18.488889 0 0 0-2.844445 25.6l36.977778 45.511111h-28.444444a18.488889 18.488889 0 0 0 0 36.977778h48.355555v19.911111h-48.355555a18.488889 18.488889 0 0 0-18.488889 19.911111 18.488889 18.488889 0 0 0 18.488889 18.488889h48.355555V611.555556a18.488889 18.488889 0 0 0 18.488889 18.488888 18.488889 18.488889 0 0 0 18.488889-18.488888v-36.977778h48.355556a18.488889 18.488889 0 0 0 18.488888-18.488889 18.488889 18.488889 0 0 0-18.488888-19.911111z" fill="#FBAE17" p-id="3108"></path></svg></div>
          <div class="feature-icon" v-if="index === 2"><svg t="1760353982426" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8626" width="64" height="64"><path d="M406.016 345.088c-1.024-10.24-2.56-19.968-5.12-30.208-14.336-4.096-27.136-12.288-38.4-23.552-17.92-17.92-27.136-39.936-27.136-66.048 0-25.6 9.216-47.616 27.136-66.048 17.92-17.92 39.936-27.136 65.024-27.136 25.6 0 47.104 9.216 65.024 27.136s27.136 39.936 27.136 66.048c0 25.6-9.216 47.616-27.136 66.048 3.584 9.728 6.144 19.968 8.704 29.696 3.584-3.072 7.168-6.144 10.752-9.728 23.552-23.552 35.328-52.224 35.328-86.016 0-33.28-11.776-61.952-35.328-86.016-23.552-23.552-51.712-35.328-84.992-35.328-33.28 0-61.44 11.776-84.992 35.328-23.552 23.552-35.328 52.224-35.328 86.016 0 33.792 11.776 61.952 35.328 86.016 18.944 18.432 39.936 29.696 64 33.792zM941.056 2.56H77.824C36.352 2.56 2.56 36.352 2.56 77.824v863.744c0 41.472 33.792 75.264 75.264 75.264h863.232c41.472 0 75.264-33.792 75.264-75.264V77.824c0-41.472-33.792-75.264-75.264-75.264zM1003.52 930.304c0 40.448-32.768 73.216-73.216 73.216H88.576C48.128 1003.52 15.36 970.752 15.36 930.304V88.576C15.36 48.128 48.128 15.36 88.576 15.36h841.728c40.448 0 73.216 32.768 73.216 73.216v841.728z m-263.68-368.64c-0.512 0-1.024-1.024-1.536-1.024-9.728-19.968-22.528-38.912-37.376-55.296-17.92-18.944-43.008-33.28-69.632-37.376l-0.512-0.512-18.944-1.024-11.776-19.968c-1.536-3.072-4.096-5.632-6.656-8.192-16.384-14.336-35.328-22.016-57.344-22.528l-19.456 4.096-0.512-1.536-0.512-0.512-60.416-230.912c-8.192-29.696-23.04-29.696-38.4-27.136 0 0-31.744 4.608-25.6 38.912L450.56 522.752c0.512 3.584 1.024 6.656 1.024 10.24 0 15.36-4.608 28.16-14.848 39.936-2.56 3.584-6.656 6.144-9.728 6.656-18.432 3.072-34.816-1.536-49.152-13.312-18.432-13.824-31.232-43.008-43.52-61.44-7.168-10.24-12.8-23.552-21.504-33.28-15.872-17.408-49.664-30.208-69.12-13.824-6.144 5.12-12.8 19.456-7.168 27.136 8.192 11.264 18.944 23.552 24.576 35.328 5.12 9.728 8.704 20.992 12.288 32.256 2.56 7.68 4.096 25.6 9.728 30.72 5.632 5.12 10.24 17.92 14.848 24.064 10.24 14.848 23.552 32.768 29.696 49.664 18.432 28.16 26.624 62.976 48.64 90.624 25.088 32.256 51.2 61.952 89.088 80.896 13.824 8.192 24.576 18.432 32.256 32.256l12.8 66.56c48.64-9.216 244.736-42.496 265.728-47.104l-12.8-57.344-0.512-0.512c4.096-14.336 8.192-29.184 12.288-44.032 3.072-11.776 4.608-23.552 5.12-35.328 1.536-31.744 2.56-63.488 4.096-94.72 0-5.632 0.512-11.264 1.536-16.896 2.56-17.92-8.192-67.584-46.08-69.632z" p-id="8627" fill="#1296db"></path></svg></div>
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
        </div>
      </div>
    </section>

  <!-- 备案信息页脚 -->
    <footer class="site-footer">
      <div class="footer-content">
        <p>
          © 2026 北京启明晨晖信息技术有限公司 版权所有
          <br/>
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">京ICP备2026004802号-1</a>
        </p>
      </div>
    </footer>    
  </div>
</template>

<script>
  import ParticlesBackground from '@/components/ParticlesBackground.vue'
export default {
  name: 'HomeView',
  components: {
    ParticlesBackground
  },
  data() {
    return {
      features: [
        {
          icon: '💬',
          title: '超长试用期',
          description: '我们为所有用户提供了长达一年的试用期，您可以免费、安心地体验我们的产品，了解AI技术的落地应用。'
        },
        {
          icon: '🔄',
          title: '低成本',
          description: '我们为个人用户和小微实体提供了超低成本的套餐，即使是个人开发者、实体小店与工作室都能毫无负担的轻松享受到我们的服务。'
        },
        {
          icon: '📊',
          title: '低技术门槛',
          description: '我们以强大的技术能力与贴合小微实体的设计方案，使AI这种原本昂贵且复杂的技术，变得像水电煤气一样便捷，您可以像点击按钮一样操作小晖AI客服平台，极大地降低了企业享受技术红利的门槛。'
        }
      ]
    }
  },
  mounted() {
    this.initParticles();
  },
  methods: {
    initParticles() {
      if (window.particlesJS) {
        window.particlesJS('particles-js', {
          particles: {
            number: { value: 70, density: { enable: true, value_area: 700 } },
            color: { value: "#7B4BFF" },
            shape: { type: "circle" },
            opacity: { value: 0.7, random: true },
            size: { value: 3, random: true },
            line_linked: {
              enable: true,
              distance: 130,
              color: "#1A4B8C",
              opacity: 0.4,
              width: 1
            },
            move: {
              enable: true,
              speed: 1.5,
              direction: "none",
              random: true,
              out_mode: "bounce"
            }
          },
          interactivity: {
            events: {
              onhover: { enable: true, mode: "repulse" },
              onclick: { enable: true, mode: "push" }
            }
          }
        });
      }
    }
  }
}
</script>

<style scoped>
/* CSS变量定义 */
.ai-service-home {
  --space-blue: #0A1A35;
  --tech-blue: #1A4B8C;
  --ai-purple:  #057FDB;/*#7B4BFF;*/
  --electric-blue: #00B4FF;
  --light-bg: #F0F4F9;
  --pure-white: #FFFFFF;

  font-family: 'Alibaba PuHuiTi', 'Microsoft YaHei', sans-serif;
  background: var(--light-bg);
  color: var(--space-blue);
  line-height: 1.6;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 导航栏样式 - 已修复宽度和按钮显示问题 */
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(10, 26, 53, 0.9);
  backdrop-filter: blur(8px);
  z-index: 1000;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
  /* 核心修正：保持水平布局，并作为定位父级 */
  display: flex;
  flex-direction: row; /* 明确设置为水平布局 */
  flex-wrap: wrap; /* 允许在需要时换行，但通常不会 */
  align-items: center; /* 垂直居中对齐内部的 logo 和 nav-links */
  justify-content: space-between; /* logo居左，nav-links居右 */
  padding: 15px max(20px, env(safe-area-inset-right)) 15px max(20px, env(safe-area-inset-left));
  box-sizing: border-box;
  /* 关键：为提示条的绝对定位提供参照 */
  position: relative;
  height: 80px;
}

.logo {
  display: flex;
  align-items: center;
  color: var(--pure-white);
  font-weight: bold;
  font-size: 1.3rem;
}

.logo-symbol {
  font-family: 'Fira Code', monospace;
  color: var(--ai-purple);
  font-size: 1.8rem;
  margin-right: 10px;
}

.nav-links a {
  margin: 0 15px;
  text-decoration: none;
  color: var(--pure-white);
  position: relative;
  font-weight: 500;
  transition: all 0.3s;
}
/* 导航链接容器优化 */
.nav-links {
  display: flex;
  align-items: center;
  gap: 15px; /* 替代margin-right */
  padding-right: 20px; /* 替代margin-right */
  flex-wrap: nowrap; /* 防止换行 */
}
.nav-links a:hover {
  color: var(--ai-purple);
}

.nav-links a:hover::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--ai-purple);
  animation: underline 0.3s forwards;
}

@keyframes underline {
  from { width: 0; }
  to { width: 100%; }
}

.cta-button {
  background: var(--ai-purple);
  color: var(--pure-white);
  padding: 8px 16px; /* 减小 padding */
  border-radius: 30px;

  transition: all 0.3s;
  white-space: nowrap; /* 防止文字换行 */
  font-size: 0.8rem; /* 可选：稍微减小字体大小 */
  min-width: fit-content; /* 确保按钮宽度适应内容 */
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(123, 75, 255, 0.4);
  color: white;
}

/* 首屏Hero样式 */
.hero-section {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: linear-gradient(135deg, var(--space-blue), #162B50);
  position: relative;
  color: var(--pure-white);
  padding-top: 0;
}

.particles-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.hero-content {
  z-index: 10;
  max-width: 1000px;
  padding: 0 20px;
}

.hero-title {
  font-size: 3.2rem;
  margin-bottom: 20px;
  width: 100%;
  background: linear-gradient(to right, var(--pure-white), var(--ai-purple));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-subtitle {
  font-size: 1.2rem;
  margin-bottom: 40px;
  opacity: 0.8;
}

.button-group {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.primary-btn {
  background: var(--ai-purple);
  color: var(--pure-white);
  padding: 15px 30px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  box-shadow: 0 4px 0 rgba(123, 75, 255, 0.3);
}

.secondary-btn {
  background: transparent;
  color: var(--pure-white);
  border: 2px solid var(--ai-purple);
  padding: 10px 15px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
}

.nav-links .secondary-btn {
  white-space: nowrap;
  padding: 8px 20px; /* 调整padding */
  min-width: 80px; /* 确保最小宽度 */
  text-align: center;
}

.primary-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(123, 75, 255, 0.5);
}

.secondary-btn:hover {
  background: rgba(123, 75, 255, 0.1);
  transform: translateY(-3px);
}

/* 功能亮点区样式 */
.features-section {
  padding: 100px 5%;
  background: linear-gradient(
    to bottom,
    #162B50 0%,           /* 与 hero-section 末尾颜色一致 */
    #F0F4F9 100%          /* 过渡到浅色背景 */
  );
  color: var(--space-blue);
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 60px;
  color: var(--pure-white);
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
}

.feature-card {
  background: var(--light-bg);
  border-radius: 15px;
  padding: 30px;
  transition: all 0.3s;
  border-bottom: 3px solid var(--ai-purple);
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(10, 26, 53, 0.1);
}

.feature-icon {
  font-size: 2.5rem;
  color: var(--ai-purple);
  margin-bottom: 20px;
}

.feature-title {
  font-size: 1.3rem;
  margin-bottom: 15px;
  color: var(--space-blue);
}

/* 客户评价区样式 */
.testimonials-section {
  padding: 100px 5%;
  background: linear-gradient(to bottom, var(--space-blue), #162B50);
  color: var(--pure-white);
}

.testimonial-card {
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 30px;
  max-width: 800px;
  margin: 0 auto;
}

.client-logo {
  height: 50px;
  margin-bottom: 20px;
  filter: brightness(0) invert(1);
}

/* 科技感细节 */
.grid-dots {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image:
    radial-gradient(circle at 1px 1px,
    rgba(255,255,255,0.1) 1px, transparent 0);
  background-size: 40px 40px;
  opacity: 0.3;
}

/* ========== 网站建设中标识样式 ========== */
.construction-banner {
  position: absolute; /* 相对于 .nav-bar 定位 */
  top: 100%; /* 使其底部紧贴导航栏底部 */
  left: 0;
  width: 100%;
  background: #f0f7ff;
  color: #4a6fa5;
  text-align: center;
  padding: 6px 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.2;
  border-bottom: 2px solid #d1e3ff;
  box-sizing: border-box;
  z-index: 999; /* 确保它在页面内容之上 */
  box-shadow: 3px 3px 3px rgb(207, 189, 184);
}

.construction-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.construction-icon {
  font-size: 0.9rem; /* 减小图标大小 */
  /* 移除 pulse 动画 */
}

@keyframes pulse {
  0% { opacity: 0.8; }
  50% { opacity: 1; }
  100% { opacity: 0.8; }
}

.construction-text {
  letter-spacing: 0.2px;
}
/* 可选：增加一个非常克制的悬停效果，让用户知道它是可读的 */
.construction-banner:hover {
  opacity: 1;
  background: #e6f0ff;
}

/* ========== 新增：备案信息页脚样式 ========== */
.site-footer {
  background: linear-gradient(135deg, #f0f4f9 0%, #e6edf7 100%); /* 使用您主色调中的浅色变体 */
  border-top: 1px solid #d1e0f0;
  color: #555; /* 文字颜色可以稍微加深，确保对比度 */
  background-color: #f5f5f5;
  border-top: 1px solid #eee;
  padding: 20px 5%;
  text-align: center;
  font-size: 0.85rem;
  color: #666;
  margin-top: 60px;

}

.footer-content p {
  margin: 0;
  line-height: 1.6;
}

.site-footer a, .site-footer p {
  font-size: 9pt;
  font-family: 'Courier New', Courier, monospace;
  color: #666;
  text-decoration: none;
  transition: color 0.2s;
}

.site-footer a:hover {
  color: #1296db;
  text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .construction-banner {
    font-size: 0.85rem;
    padding: 8px 10px;
    margin-top: 60px; /* 移动端导航栏通常较矮 */
  }
  .construction-content {
    flex-direction: row;
    gap: 8px;
  }
}
</style>